import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { gratuityBasisPoints } from "@/lib/reservation-charges";

export function ReservationGratuity({ percent, suggestedBasisPoints, savedBasisPoints, busy, locked, onChange, onApply }: {
  percent: string;
  suggestedBasisPoints: number;
  savedBasisPoints: number;
  busy: boolean;
  locked: boolean;
  onChange: (percent: string) => void;
  onApply: () => void;
}) {
  const basisPoints = gratuityBasisPoints(percent);
  const changed = basisPoints !== savedBasisPoints;
  const presets = [...new Set([0, suggestedBasisPoints, 1500, 1800, 2000])].filter((rate) => rate >= 0 && rate <= 10000);
  return <fieldset className="reservation-gratuity" disabled={busy || locked}>
    <legend>Optional gratuity</legend>
    <p>Your choice starts at zero. Gratuity is calculated on the discounted experience price, before tax and fixed fees.</p>
    <div className="reservation-gratuity-presets" role="group" aria-label="Gratuity percentage">
      {presets.map((rate) => <Button type="button" key={rate} variant={basisPoints === rate ? "default" : "outline"} aria-pressed={basisPoints === rate} onClick={() => onChange(String(rate / 100))}>{rate === 0 ? "No gratuity" : `${rate / 100}%${rate === suggestedBasisPoints ? " suggested" : ""}`}</Button>)}
    </div>
    <div className="reservation-gratuity-custom">
      <label>Custom percentage<Input type="number" min={0} max={100} step="0.01" value={percent} aria-invalid={basisPoints === null} onChange={(event) => onChange(event.target.value)} /></label>
      <Button type="button" variant="outline" disabled={basisPoints === null || !changed || busy || locked} onClick={onApply}>{busy ? "Updating…" : "Apply gratuity"}</Button>
    </div>
    <p role="status">{locked ? "Payment has started. Your gratuity is locked to that payment total." : basisPoints === null ? "Enter a percentage from 0 to 100, with at most two decimal places." : changed ? "Apply your choice to update the total before continuing." : savedBasisPoints ? `${savedBasisPoints / 100}% gratuity included in the total.` : "No gratuity included."}</p>
  </fieldset>;
}
